const TENANT_FALLBACK_STYLE_ID = "tenant-fallback-css";

function rewriteFallbackAssetUrls(cssText: string): string {
  const baseUrl = import.meta.env.BASE_URL ?? "/";
  const normalizedBaseUrl = baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`;

  return cssText.replace(
    /url\((["']?)\/asset\//g,
    `url($1${normalizedBaseUrl}asset/`
  );
}

export function injectTenantFallbackCss(cssText: string): void {
  if (typeof document === "undefined") return;

  const rewrittenCss = rewriteFallbackAssetUrls(cssText);
  const existingStyle = document.getElementById(
    TENANT_FALLBACK_STYLE_ID
  ) as HTMLStyleElement | null;

  if (existingStyle) {
    if (existingStyle.textContent?.includes(rewrittenCss)) return;
    existingStyle.textContent = existingStyle.textContent
      ? `${existingStyle.textContent}\n\n${rewrittenCss}`
      : rewrittenCss;
    return;
  }

  const style = document.createElement("style");
  style.id = TENANT_FALLBACK_STYLE_ID;
  style.textContent = rewrittenCss;

  // Append after Vite-managed styles so the generated fallback variables are
  // available before we move the CDN tenant.css link to the end of <head>.
  document.head.appendChild(style);
}
